import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { PartnerModel } from 'projects/core/src/lib/models/partner.model';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-partner-list',
  templateUrl: './partner-list.component.html',
  styleUrls: ['./partner-list.component.scss']
})
export class PartnerListComponent extends BaseList implements OnInit {

  public partners: Array<PartnerModel> = [];

  protected rightLoad = 'admin.partner.list';
  protected rightNew = 'admin.partner.create';
  protected rightOpen = 'admin.partner.show';
  protected apiUrl = '/partners';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    protected transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.partners'));
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('partners').subscribe({
      next: (partners: any) => {
        this.partners = [];
        partners.data.forEach((partner: any) => {
          this.partners.push(new PartnerModel().deserialize(partner));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
